module.exports = __webpack_public_path__ + "img/Morocco.11c16fef.gif";